import { Grid2 as Grid, Alert } from "@mui/material";
import { useWatch } from "react-hook-form";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { AgreementsAutocomplete } from "@shared/components/AutocompleteFields";
import { NOTIFICATION_TYPES, parseEmails } from "@modules/notifications/validations";

export function RecipientsStep() {
  const translate = useTranslate();
  const [type, emailsText] = useWatch({ name: ["notification_type", "emails_text"] });
  const isPush = type === "push";

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Select
          name="notification_type"
          label={translate("notifications_emails_admin.fields.notification_type")}
          options={NOTIFICATION_TYPES.map((value) => ({
            value,
            label: translate(`notifications_emails_admin.types.${value}`),
          }))}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("notifications_emails_admin.fields.agreement")}
          required={isPush}
        />
      </Grid>

      {isPush ? (
        <Grid size={{ xs: 12 }}>
          <Alert severity="warning">{translate("notifications_emails_admin.instructions.push")}</Alert>
        </Grid>
      ) : (
        <Grid size={{ xs: 12 }}>
          <Form.Input
            name="emails_text"
            label={`${translate("notifications_emails_admin.fields.emails")} (${parseEmails(emailsText).length})`}
            instructions={translate("notifications_emails_admin.instructions.emails")}
            multiline
            rows={10}
            required
          />
        </Grid>
      )}
    </Grid>
  );
}
